import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-white text-primary-navy mt-auto pt-16 pb-8 border-t-[8px] border-[#3B82F6] relative overflow-hidden">
      
      {/* Background Texture */}
      <div className="absolute inset-0 w-full h-full opacity-[0.03] bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-4 lg:px-8 relative z-10">
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          
          {/* Column 1: Brand & Mission */}
          <div className="space-y-4">
            <h3 className="font-heading font-black text-3xl">
              <span className="text-primary-navy">Positive</span> <span className="text-[#3B82F6]">Somebody</span>
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed font-medium">
              Empowering youth and families in Mid-Michigan through emotional awareness, positive coping skills, and community resilience.
            </p>
            
            <div className="flex flex-col items-start gap-2">
                <div className="inline-flex items-center gap-2 px-3 py-1 bg-blue-50 rounded-full border border-blue-100">
                <span className="text-lg">🛡️</span>
                <p className="text-xs font-bold text-primary-navy uppercase tracking-wide">
                    501(c)(3) Non-Profit
                </p>
                </div>
                {/* ADDED: EIN Number */}
                <p className="text-xs text-gray-400 font-bold ml-1">EIN: 84-4387253</p>
            </div>
          </div>

          {/* Column 2: Get Involved */}
          <div>
            <h4 className="font-heading font-bold text-xl mb-4 text-primary-navy flex items-center gap-2">
              <span className="text-[#3B82F6] text-xl">🚀</span> Get Involved
            </h4>
            <ul className="space-y-3 text-sm font-medium text-gray-600">
              <li>
                <Link to="/donate" className="hover:text-[#3B82F6] hover:translate-x-1 transition-all inline-block">Donate</Link>
              </li>
              <li>
                <a 
                  href="mailto:beapositivesomebody@gmail.com?subject=Volunteer%20Interest&body=Hello%2C%0D%0A%0D%0AI%20would%20like%20to%20volunteer%20with%20Positive%20Somebody.%20Please%20let%20me%20know%20about%20upcoming%20opportunities.%0D%0A%0D%0AThanks%2C%0D%0A%5BYour%20Name%5D" 
                  className="hover:text-[#3B82F6] hover:translate-x-1 transition-all inline-block"
                >
                  Volunteer
                </a>
              </li>
              <li>
                <Link to="/events#sponsor" className="hover:text-[#3B82F6] hover:translate-x-1 transition-all inline-block">Sponsor an Event</Link>
              </li>
              <li>
                <a 
                  href="mailto:beapositivesomebody@gmail.com?subject=General%20Inquiry" 
                  className="hover:text-[#3B82F6] hover:translate-x-1 transition-all inline-block"
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Contact Info */}
          <div>
            <h4 className="font-heading font-bold text-xl mb-4 text-primary-navy flex items-center gap-2">
              <span className="text-[#3B82F6] text-xl">📬</span> Contact
            </h4>
            <div className="space-y-4 text-sm font-medium text-gray-600">
              <div className="group">
                <a href="mailto:beapositivesomebody@gmail.com?subject=General%20Inquiry" className="flex items-start gap-3 hover:text-[#3B82F6] transition-colors">
                  <span className="bg-blue-50 p-2 rounded-full text-lg group-hover:bg-blue-100 transition-colors">✉️</span>
                  <span className="self-center">beapositivesomebody@gmail.com</span>
                </a>
              </div>
              <div className="flex items-start gap-3">
                <span className="bg-blue-50 p-2 rounded-full text-lg">📍</span>
                <p className="self-center">
                  405 W. Greenlawn Ave, STE 400<br />
                  Lansing, MI 48910
                </p>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="border-t-2 border-gray-100 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs font-bold text-gray-400">
          <p>© {new Date().getFullYear()} Positive Somebody. All Rights Reserved.</p>
          <p className="text-center md:text-right">
            Positive Somebody is a registered 501(c)(3) non-profit organization.<br />
            <span className="font-normal opacity-80">Contributions are tax-deductible to the extent allowed by law.</span>
          </p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;